import dayjs from 'dayjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBuildInfo } from '@app/api/interfaces/build-info';
import { HttpInterceptorParams } from '@app/core/interceptors/classes/http-interceptor-params';

@Injectable({
  providedIn: 'root',
})
export class BuildInfoApiService {
  constructor(private readonly httpClient: HttpClient) {}

  public get(): Observable<IBuildInfo> {
    const url = `/build-info.json?date=${dayjs().valueOf()}`; // prevent caching data

    return this.httpClient.get<IBuildInfo>(url, {
      params: new HttpInterceptorParams({ toIgnoreAll: true, toIgnoreNavigationCancellation: true }),
    });
  }
}
